/**
 * Density strategy.
 */
function AdsNinjaDensityStrategy(){

}

/**
 * Determines the distance between zones.
 * 
 * @param {number} numberOfAdsLeftToInject 
 * @param {number} relativeSpaceLeftToInjectAdsIn 
 * @param {number} minimumPixelDistanceBetweenZones
 * @returns {number}
 */
AdsNinjaDensityStrategy.prototype.determineDistanceBetweenZones = function(
    numberOfAdsLeftToInject, 
    relativeSpaceLeftToInjectAdsIn, 
    minimumPixelDistanceBetweenZones
){

    if(numberOfAdsLeftToInject <= 0){

        return null;
    }

    // Balanced.
    return window.adsNinja.utils.roundUpToTwoDecimalPoints(Math.max(Math.floor((relativeSpaceLeftToInjectAdsIn / (numberOfAdsLeftToInject + 1))), minimumPixelDistanceBetweenZones));
};

window.AdsNinjaDensityStrategy = AdsNinjaDensityStrategy;